import {
   ADD_STOCK_TRANSFER,
   UPDATE_STOCK_TRANSFER,
   DELETE_STOCK_TRANSFER,
   GET_STOCK_TRANSFER,
   GET_STOCK_TRANSFER_BY_ID,
   GET_STOCK_TRANSFER_LAST_DOCNO,
   MULTI_DELETE_ACCOUNT,
} from '../types';

// const initialState = { list: [], single: null };
const initialState = {
   list: [],
   single: [],
   pagination: {
      limit: 10,
      nextPage: null,
      totalPages: 1,
      currentPage: 1,
      hasNextPage: false,
      previousPage: null,
      totalProducts: 0,
      hasPreviousPage: false,
   },
   single: null,
   broker: null,
};

const reducer = (state = initialState, action) => {
   const { type, payload } = action;

   switch (type) {
      case GET_STOCK_TRANSFER:
         return { ...state, list: payload.data, pagination: payload.pagination };
      case GET_STOCK_TRANSFER_BY_ID:
         return { ...state, single: payload.data, pagination: payload.pagination };
      case GET_STOCK_TRANSFER_LAST_DOCNO:
         return { ...state, last: payload.data, pagination: payload.pagination };

      case UPDATE_STOCK_TRANSFER:
         return {
            ...state,
            list: state.list.map((item) => (item.id === payload.id ? payload : item)),
         };

      case ADD_STOCK_TRANSFER:
         return {
            ...state,
            list: [payload, ...state.list],
         };

      case DELETE_STOCK_TRANSFER:
         return {
            ...state,
            list: state.list.filter((item) => item.id !== payload.id),
         };

      default:
         return state;
   }
};

export default reducer;
